<script setup name="TvbButton">
defineProps({
  type: { type: String, default: null },
  // animation: https://codepen.io/sarath-ar/pen/dMKxxM 目前添加了ui效果及效果1 其余效果自行添加
  animation: { type: String, default: 'default' },
  icon: { type: String, default: null },
  path: { type: String, default: '/' },
  linkRef: { type: Number, default: null },
  linkTarget: { type: Number, default: null }
})
</script>

<template>
  <button
    class="tvb-button"
    :class="[
      animation ? `animation-${animation}` : null,
      icon ? 'icon' : null,
      type ? 'btn-' + type : ''
    ]"
  >
    <tvb-router-link class="span" :to="path" :link-target="linkTarget" :link-rel="linkRef">
      <slot /> <tvb-svg-icon v-if="icon" :name="icon" />
    </tvb-router-link>
  </button>
</template>

<style lang="scss" scoped>
.tvb-button {
  display: inline-block;
  position: relative;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(40px);
  padding: 0;
  user-select: none;
  z-index: 9;
  --tvb-button-padding: 0 20px;
  --tvb-button-height: 36px;
  --tvb-button-line-height: var(--tvb-button-height);
  letter-spacing: 0.3px;

  > .span {
    display: block;
    height: var(--tvb-button-height);
    line-height: var(--tvb-button-line-height);
    padding: var(--tvb-button-padding);
    text-decoration: none;
    color: inherit;
    white-space: nowrap;
  }

  &.icon {
    > .span {
      --tvb-button-padding: 0 16px 0 20px;
    }
  }

  &.btn-more {
    --tvb-hairline-border-radius: calc(2 * 12px);
    box-sizing: border-box;
    background-color: #f5f6f7;
    font-size: 15px;
    letter-spacing: 0.3px;
    color: #231f20;
    backdrop-filter: none;
    border-radius: 12px;
    width: 97px;
    > .span {
      --tvb-button-padding: 7px 10px 7px 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.icon {
      .svg-icon {
        font-size: 12px;
        // transform: scaleX(-1);
      }
    }
  }

  &.btn-more-text {
    color: #444444;
    font-size: 14px;
    > .span {
      --tvb-button-padding: 0px;
      display: flex;
      align-items: center;
    }
    &.icon {
      .svg-icon {
        font-size: 10px;
      }
    }
  }

  &.btn-big-more {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 42px;
    background: #fcfcfc;
    border-radius: 16px;
    border: 0.5px solid rgba(163, 178, 188, 0.35);
    box-sizing: border-box;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    font-weight: 400;
    color: #444444;
    letter-spacing: 0.3px;
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
      width: 10px;
      height: 10px;
    }

    &:active {
      opacity: 0.75;
    }
  }

  // &[class*='animation'] {
  &.animation-default,
  &.animation-1 {
    &::before,
    &::after {
      content: '';
      width: 0;
      height: 1.5px;
      position: absolute;
      transition: all 0.3s linear;
      background: #cccccc;
    }

    &:hover {
      &::before,
      &::after {
        width: 100%;
      }
      > .span {
        &::before,
        &::after {
          height: 100%;
        }
      }
    }

    > .span {
      border: 0.5px solid rgba(255, 255, 255, 0.16);
      box-sizing: border-box;
      display: flex;
      align-items: center;

      &::before,
      &::after {
        content: '';
        top: 0px;
        width: 1.5px;
        height: 0;
        position: absolute;
        transition: all 0.3s linear;
        background: #cccccc;
      }
      &::before {
        left: 0;
      }
      &::after {
        right: 0;
      }
    }
  }

  &.animation-default {
    &::before {
      right: 0;
      top: 0;
    }
    &::after {
      left: 0;
      bottom: 0;
    }
    > .span {
      &::before {
        height: 100%;
        left: 0;
      }
      &::after {
        height: 100%;
        right: 0;
      }
    }
  }

  &.animation-1 {
    &::before,
    &::after {
      transition-delay: 0.3s;
    }

    &::before {
      right: 0;
      top: 0;
    }

    &::after {
      left: 0;
      bottom: 0;
    }

    > .span {
      &::before,
      &::after {
        transition-delay: 0s;
      }

      &::before {
        left: 0;
        top: 0;
      }

      &::after {
        right: 0;
        bottom: 0;
      }
    }

    &:hover {
      &::before,
      &::after {
        transition-delay: 0s;
      }

      > .span {
        &::before,
        &::after {
          transition-delay: 0.3s;
        }
      }
    }
  }

  &.animation-more {
    transition:
      color 0.15s linear,
      background-color 0.15s linear;
    &:hover {
      --icon_list_arrow_grey: #231f20;
      color: #231f20;
      background-color: #eceff3;
    }
  }

  &.animation-2 {
    > .span {
      position: relative;
      // z-index: 1;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.2);
      opacity: 0;
      transition: opacity 0.3s linear;
      z-index: 0;
    }
    &:hover::before {
      opacity: 1;
    }
  }

  &:active {
    opacity: 0.75;
  }
}
</style>
